module.exports = __webpack_public_path__ + "images/0a7ed5a0b2e15e721154033a42326780-apricot.svg";